"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAddress = void 0;
const types_shared_1 = require("../types.shared");
const addresses_1 = require("../helpers/addresses");
const validateAddress = ({ userState, inRangeLocations, }) => {
    if (!(userState === null || userState === void 0 ? void 0 : userState.location)) {
        return {
            result: (0, types_shared_1.error)({
                code: (userState === null || userState === void 0 ? void 0 : userState.date) ? 'INVALID_ADDRESS' : 'INVALID_ADDRESS_NO_DATE',
            }),
            newLocations: inRangeLocations,
        };
    }
    const { latitude, longitude, street, postcode, city } = (0, addresses_1.basketLocationToAddress)(userState.location);
    if (!latitude || !longitude) {
        return {
            result: (0, types_shared_1.error)({ code: 'NO_LATITUDE_OR_LONGITUDE' }),
            newLocations: inRangeLocations,
        };
    }
    if (!street || !postcode || !city || street === postcode || street === city) {
        return {
            result: (0, types_shared_1.error)({ code: 'NO_STREET_ADDRESS' }),
            newLocations: inRangeLocations,
        };
    }
    if (inRangeLocations.length === 0) {
        return {
            result: (0, types_shared_1.error)({ code: 'VENDER_COVERAGE' }),
            newLocations: [],
        };
    }
    return {
        result: (0, types_shared_1.ok)(),
        newLocations: inRangeLocations,
    };
};
exports.validateAddress = validateAddress;
